// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ResponsiveImage Component Styles */

.ResponsiveImage_wrapper__bk5aL {
  position: relative;
  overflow: hidden;
  border-radius: inherit;
}

.ResponsiveImage_image__a8BKz {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0;
  transition: opacity 0.4s ease;
}

.ResponsiveImage_image__a8BKz.ResponsiveImage_loaded__gjahy {
  opacity: 1;
}

/* Shimmer loading effect */
.ResponsiveImage_shimmer__Cq2bZ {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.4) 50%,
    rgba(255, 255, 255, 0) 100%
  );
  animation: ResponsiveImage_shimmer__Cq2bZ 1.5s infinite;
}

@keyframes ResponsiveImage_shimmer__Cq2bZ {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/common/ResponsiveImage.module.css"],"names":[],"mappings":"AAAA,qCAAqC;;AAErC;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,QAAQ;EACR;;;;;GAKC;EACD,uDAAgC;AAClC;;AAEA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,2BAA2B;EAC7B;AACF","sourcesContent":["/* ResponsiveImage Component Styles */\n\n.wrapper {\n  position: relative;\n  overflow: hidden;\n  border-radius: inherit;\n}\n\n.image {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  opacity: 0;\n  transition: opacity 0.4s ease;\n}\n\n.image.loaded {\n  opacity: 1;\n}\n\n/* Shimmer loading effect */\n.shimmer {\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(\n    90deg,\n    rgba(255, 255, 255, 0) 0%,\n    rgba(255, 255, 255, 0.4) 50%,\n    rgba(255, 255, 255, 0) 100%\n  );\n  animation: shimmer 1.5s infinite;\n}\n\n@keyframes shimmer {\n  0% {\n    transform: translateX(-100%);\n  }\n  100% {\n    transform: translateX(100%);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `ResponsiveImage_wrapper__bk5aL`,
	"image": `ResponsiveImage_image__a8BKz`,
	"loaded": `ResponsiveImage_loaded__gjahy`,
	"shimmer": `ResponsiveImage_shimmer__Cq2bZ`
};
export default ___CSS_LOADER_EXPORT___;
